import gsap from "gsap";


const Sidebar = (() => {

const SELECTOR = "sticky-sidebar";

const initialize = () => {

    const sidebar = document.getElementById(SELECTOR);

    if (!sidebar) return;

    gsap.fromTo( sidebar,
        {
            autoAlpha: 0,
            bottom: "-2rem"
        },
        {
            autoAlpha: 1,
            bottom: "2rem",
            right: "2rem",
            duration: .5,
            ease: "ease.in",
            delay: 1
        }
    );


}

return {
    initialize
}


})();


export default Sidebar;